import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { COLOR_DANGER } from "../../../../constants/theme";

export default function PdfPreview({ size }: { size?: SizeProp }) {
  return (
    <FontAwesomeIcon
      icon={["far", "file-pdf"]}
      size={!size ? "5x" : size}
      className="filePreview"
      color={COLOR_DANGER}
    />
  );
}